import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { hydrate } from 'react-dom';
import { loadableReady } from '@loadable/component';
import 'focus-visible';
import Root from 'components/Root';
import configureStore from 'store';
import { DEFAULT_LOCALE } from 'utils';
var initialState = window.APP_INITIAL_STATE || {};
var translationsLocale = window.APP_TRANSLATIONS_LOCALE || DEFAULT_LOCALE;
var routerBasename = window.APP_ROUTER_BASENAME || process.env.APP_ROUTER_BASENAME;
delete window.APP_INITIAL_STATE;
delete window.APP_TRANSLATIONS_LOCALE;
delete window.APP_ROUTER_BASENAME;
delete window.APP_TEMPLATE_PARAMS;
var store = configureStore(initialState);

var render = function render(Component) {
  hydrate( /*#__PURE__*/_jsx(Component, {
    store: store,
    locale: translationsLocale,
    routerBasename: routerBasename,
    env: "client"
  }), document.getElementById('root'));
};

loadableReady(function () {
  if (module.hot) {
    module.hot.accept('components/Root', function () {
      var Component = require('components/Root')["default"]; //eslint-disable-line


      render(Component);
    });
  }

  render(Root);
});